import React, { useEffect, useState, useRef } from "react";
import { errorParser, numberWithCommas } from "../../utils/helpers";
import {
  SearchOutlined,
  EditOutlined,
  ReloadOutlined,
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import ImageChecker from "../../components/Generic/ImageChecker";

import {
  PageHeader,
  Pagination,
  Input,
  Button,
  Table,
  Tabs,
  Spin,
  Typography,
  Tag,
  List,
  Popconfirm,
  message,
  DatePicker,
} from "antd";

import moment from "moment";

import SalesTable from "../../components/dailysales/Table";

import PosSalesModal from "../../components/dailysales/PosSalesModal";
import FixSaleIngredientsButton from "../../components/dailysales/FixSaleIngredientsButton";

import AddWastedItemsModal from "../../components/wasteditems/AddWastedItemsModal";
import WasteTable from "../../components/wasteditems/Table";

import AddWastedMenuModal from "../../components/wastedmenu/AddWastedMenuModal";
import WastedMenuTable from "../../components/wastedmenu/Table";

import AddPulloutModal from "../../components/pullout/AddPulloutModal";
import PullOutTable from "../../components/pullout/Table";

import { getLocations } from "../../Redux/actions/locationsActions";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  loadMoreSalesData,
  setSaleDate,
} from "../../Redux/actions/dailysalesActions";
import {
  loadMoreWastableData,
  voidWastedItems,
} from "../../Redux/actions/wastableActions";
import {
  loadMoreWastedMenuData,
  voidWastedMenu,
} from "../../Redux/actions/wastedmenuActions";

import { loadMorePullOutData } from "../../Redux/actions/PulloutActions";

import {
  voidSale,
} from "../../Redux/actions/dailysalesActions";

import { setProductInventoryWithLocation } from "../../Redux/actions/inventoryActions";

import "./styles.scss";
import "./styles.css";

const { TabPane } = Tabs;

const { Search } = Input;
const INITIAL_STATE = {
  searchText: "",
};
const API_URL = "sales";

const PAGENAME = "Sale";

const MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },
  {
    title: "Address",
    key: "address",
    type: "text",
  },
  {
    title: "phone",
    key: "contactno",
    type: "number",
  },
  {
    title: "contact person",
    key: "contact_person",
    type: "text",
  },
  {
    title: "operating hours",
    key: "operating_hours",
    type: "text",
  },
];

const Index = (props) => {
  const [loading, setLoading] = useState(false);
  const [mainSearch, setMainSearch] = useState(null);
  const [resetTable, setResetTable] = useState(false);

  const [modalMode, setModalMode] = useState("edit");
  const [currentSelected, setCurrentSelected] = useState(null);
  const [voidingSaleIds, setVoidingSaleIds] = useState({});
  const [locallyVoidedSaleIds, setLocallyVoidedSaleIds] = useState({});
  const [processingMessage, setProcessingMessage] = useState("");

  const [tabMode, setTabMode] = useState("daily");

  const tableRef = useRef();
  const dispatch = useDispatch();
  const { crudData, crudDataCount, locations, user } = useSelector(
    (state) => ({
      crudData: state.dailysales.data,
      crudDataCount: state.dailysales.dataCount,
      user: state.auth.user,
      locations: state.locations.locations,
    }),
    shallowEqual
  );
  useEffect(() => {
    setResetTable(!resetTable);
  }, []);

  useEffect(() => {
    dispatch(getLocations());
  }, []);

  const onSearch = (value) => {
    setMainSearch(value);
  };

  const itemSelected = (value) => {
    setModalMode("edit");
    setCurrentSelected(value);
  };
  const createDestinationFilter = () => {
    const filters = [];

    if (user) {
      filters.push({ text: user.branch_name, value: user.branch_name });

      if (user.role === "admin" || user.role === "manager") {
        locations.forEach((loc) =>
          filters.push({ text: loc.name, value: loc.name })
        );
      }
    }

    return filters;
  };

  const voidThisSale = async (record) => {
    var saleId = record?.id || record?.key;

    if (
      !saleId ||
      record?.status === "voided" ||
      loading ||
      voidingSaleIds[saleId] ||
      locallyVoidedSaleIds[saleId]
    ) {
      return;
    }

    setLoading(true);
    setVoidingSaleIds((current) => ({ ...current, [saleId]: true }));
    setProcessingMessage("Voiding sale. Please wait...");
    message.info("voiding sale");

    try {
      await dispatch(voidSale(record));
      setLocallyVoidedSaleIds((current) => ({ ...current, [saleId]: true }));
      setResetTable((current) => !current);
    } catch (error) {
      message.error(errorParser(error));
    } finally {
      setVoidingSaleIds((current) => {
        var next = { ...current };
        delete next[saleId];
        return next;
      });
      setProcessingMessage("");
      setLoading(false);
    }
  };

  const voidThisWastedMenu = async (record) => {
    var used_ingredients = record.used_ingredients;

    if (!loading) {
      setLoading(true);
      message.info("recording sales");

      await Promise.all(
        used_ingredients.map(async (indx, i) => {
          var product3 = await dispatch(
            setProductInventoryWithLocation(
              indx.product,
              indx.product_name,
              indx.quantity,
              "add",
              "voided Wasted Menu",
              record.branch,
              record.branch_name
            )
          );
        })
      );
      var newsold = await dispatch(voidWastedMenu(record));
      setResetTable(!resetTable);
      setLoading(false);
    }
  };

  const voidThisWasteditems = async (record) => {
    var wasted_items = record.wasted_items;

    if (!loading) {
      setLoading(true);
      message.info("recording sales");

      await Promise.all(
        wasted_items.map(async (indx, i) => {
          if (indx.id && indx.quantity) {
            var product3 = await dispatch(
              setProductInventoryWithLocation(
                indx.id,
                indx.name,
                indx.quantity,
                "add",
                "voided wasted Items",
                record.branch,
                record.branch_name
              )
            );
          }
        })
      );
      var newsold = await dispatch(voidWastedItems(record));
      setResetTable(!resetTable);
      setLoading(false);
    }
  };

  const changeSaleDate = async (record, newdate) => {
    if (!loading) {
      setLoading(true);
      message.info("recording sales");

      var newsold = await dispatch(setSaleDate(record, newdate));
      setResetTable(!resetTable);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Branch",
      dataIndex: "branch_name",
      key: "branch_name",
      filters: createDestinationFilter(),
      onFilter: (value, record) => value.includes(record.branch_name),
      sorter: (a, b) => a.branch_name.localeCompare(b.branch_name),
    },
    {
      title: "Sale Date",
      dataIndex: "sale_date",
      key: "sale_date",
      sorter: (a, b) => a.sale_date.localeCompare(b.sale_date),
      render: (text, record, index) => {
        var qty_reg = 0;

        record.products_sold.forEach((item) => {
          qty_reg += parseFloat(item.qty_reg ?? 0);
        });

        return (
          <div className="vertical">
            {record.status == "voided" ? <Tag color="red">VOIDED</Tag> : null}
            <span> sale date: </span>

            {user.role == "admin" || user.role == "manager" ? (
              <DatePicker
                onChange={(e) => {
                  changeSaleDate(record, e);
                }}
                placeholder={moment(text).format("LLL")}
              />
            ) : (
              <span> {moment(text).format("LLL")} </span>
            )}
            <span>{"-----------"}</span>
            <span> create date: </span>
            <span> {moment(record.created_at).format("LLL")} </span>
            <span>{"-----------"}</span>
            <span> {record.created_name}</span>
            <span> {record.seller?.name}</span>

            {user.role == "admin" ||
            user.role == "manager" ||
            user.role == "oic" ? (
              <div className="vertical">
                <span>{"-----------"}</span>
                {record?.payment_method ? (
                  <span> {`${record?.payment_method}`}</span>
                ) : null}
                <span>
                  {" "}
                  items disc:{" "}
                  {`₱ ${numberWithCommas(
                    parseFloat(record?.breakdown?.itemsDiscount).toFixed(2)
                  )}`}
                </span>
                <span>
                  order disc:{" "}
                  {`₱ ${numberWithCommas(
                    parseFloat(record?.breakdown?.orderDisc).toFixed(2)
                  )}`}
                </span>
                <span> total sell price: </span>
                <span>{`₱ ${numberWithCommas(
                  parseFloat(record.total_sell_price).toFixed(2)
                )}`}</span>
              </div>
            ) : null}

            <span>{"-----------"}</span>
            <div className="vertical">
              <span> Total Counts: </span>
              <label className="tinyText">
                Regular: {numberWithCommas(parseFloat(qty_reg ?? 0))}
              </label>
            </div>
          </div>
        );
      },
    },
    {
      title: "Products Sold",

      render: (text, record, index) => {
        return (
          <List
            className="Itemlist"
            itemLayout="horizontal"
            dataSource={record.products_sold}
            size={"small"}
            renderItem={(item) => (
              <List.Item
              // actions={[
              //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
              //     <DeleteOutlined  />
              //   </Button>
              // ]}
              >
                <List.Item.Meta
                  avatar={
                    <ImageChecker
                      url={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                      success={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                      fail={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                    />
                  }
                  title={<h6>{item.name}</h6>}
                  description={
                    <div className="horizontalItem">
                      <div className="horizontalItem">
                        <label> x{item.quantity_sold} </label>
                        <label className="tinyText">{item.unit}</label>
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        );
      },
    },
    {
      title: "Items Used",

      render: (text, record, index) => {
        return (
          <List
            className="Itemlist"
            itemLayout="horizontal"
            dataSource={record.used_ingredients}
            size={"small"}
            renderItem={(item) => (
              <List.Item
              // actions={[
              //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
              //     <DeleteOutlined  />
              //   </Button>
              // ]}
              >
                <List.Item.Meta
                  avatar={
                    <ImageChecker
                      url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                      success={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                      fail={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                    />
                  }
                  title={<h7>{item.product_name}</h7>}
                  description={
                    <div className="horizontalItem">
                      <div className="horizontalItem">
                        <label> x{item.quantity} </label>
                        <label className="tinyText">{item.unit}</label>
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        );
      },
    },
  ];

  const wastedmenucolumns = [
    {
      title: "Branch",
      dataIndex: "branch_name",
      key: "branch_name",
      filters: createDestinationFilter(),
      onFilter: (value, record) => value.includes(record.branch_name),
      sorter: (a, b) => a.branch_name.localeCompare(b.branch_name),
    },
    {
      title: "Wasted Date",
      dataIndex: "wasted_date",
      key: "wasted_date",
      sorter: (a, b) => a.wasted_date.localeCompare(b.wasted_date),
      render: (text, record, index) => {
        return (
          <div className="vertical">
            <span> wasted date: </span>
            <span> {moment(text).format("LLL")} </span>
            <span>{"-----------"}</span>
            <span> create date: </span>
            <span> {moment(record.created_at).format("LLL")} </span>
            <span>{"-----------"}</span>
            <span> {record.created_name}</span>
          </div>
        );
      },
    },
    {
      title: "Products Wasted",

      render: (text, record, index) => {
        return (
          <List
            className="Itemlist"
            itemLayout="horizontal"
            dataSource={record.products_wasted}
            size={"small"}
            renderItem={(item) => (
              <List.Item
                // actions={[
                //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
                //     <DeleteOutlined  />
                //   </Button>
                // ]}
                key={item.id}
              >
                <List.Item.Meta
                  avatar={
                    <ImageChecker
                      url={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                      success={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                      fail={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                    />
                  }
                  title={<h7>{item.name}</h7>}
                  description={
                    <div className="horizontalItem">
                      <div className="horizontalItem">
                        <label> x{item.quantity_wasted} </label>
                        <label className="tinyText">{item.unit}</label>
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        );
      },
    },
    {
      title: "Items Used",

      render: (text, record, index) => {
        return (
          <List
            className="Itemlist"
            itemLayout="horizontal"
            dataSource={record.used_ingredients}
            size={"small"}
            renderItem={(item) => (
              <List.Item
              // actions={[
              //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
              //     <DeleteOutlined  />
              //   </Button>
              // ]}
              >
                <List.Item.Meta
                  avatar={
                    <ImageChecker
                      url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                      success={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                      fail={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                    />
                  }
                  title={<h7>{item.product_name}</h7>}
                  description={
                    <div className="horizontalItem">
                      <div className="horizontalItem">
                        <label> x{item.quantity} </label>
                        <label className="tinyText">{item.unit}</label>
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        );
      },
    },
  ];

  const filterColumnSales = () => {
    var newColumns = columns;
    const voidcol = [
      {
        title: "Void",
        render: (text, record, index) => {
          var saleId = record?.id || record?.key;
          var isVoidingSale = saleId && voidingSaleIds[saleId];
          var isVoidedSale =
            record.status == "voided" ||
            (saleId && locallyVoidedSaleIds[saleId]);

          return (
            <div className="content">
              <Popconfirm
                title="Are you sure you want to void this sale?"
                onConfirm={() => {
                  voidThisSale(record);
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="danger"
                  loading={isVoidingSale}
                  disabled={isVoidedSale || isVoidingSale}
                >
                  void
                </Button>
              </Popconfirm>
              {record.products_sold.length > 0 &&
              record.used_ingredients.length == 0 &&
              (user.email == "ekcotoco@gmail.com" ||
                user.email == "anthony.christopher.ong@gmail.com") ? (
                <FixSaleIngredientsButton
                  currentSalesOrder={record}
                  onModalClose={() => {
                    setResetTable(!resetTable);
                  }}
                />
              ) : null}
            </div>
          );
        },
      },
    ];

    if (
      (user.role == "admin" || user.role == "manager") &&
      tabMode != "voided"
    ) {
      newColumns = newColumns.concat(voidcol);
    }

    return newColumns;
  };

  const wastesColumns = [
    {
      title: "Branch",
      dataIndex: "branch_name",
      key: "branch_name",
      filters: createDestinationFilter(),
      onFilter: (value, record) => value.includes(record.branch_name),
      sorter: (a, b) => a.branch_name.localeCompare(b.branch_name),
    },
    {
      title: "Create Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
      render: (text, record, index) => {
        return (
          <div className="vertical">
            <span> create date: </span>
            <span> {moment(record.created_at).format("LLL")} </span>
            <span>{"-----------"}</span>
            <span> {record.created_name}</span>
          </div>
        );
      },
    },
    {
      title: "Products Wasted",

      render: (text, record, index) => {
        return (
          <List
            className="Itemlist"
            itemLayout="horizontal"
            dataSource={record.wasted_items}
            size={"small"}
            renderItem={(item) => (
              <List.Item
              // actions={[
              //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
              //     <DeleteOutlined  />
              //   </Button>
              // ]}
              >
                <List.Item.Meta
                  avatar={
                    <ImageChecker
                      url={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                      success={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                      fail={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                    />
                  }
                  title={<h7>{item.name}</h7>}
                  description={
                    <div className="horizontalItem">
                      <div className="horizontalItem">
                        <label> x{item.quantity} </label>
                        <label className="tinyText">{item.unit}</label>
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        );
      },
    },
  ];

  const filterColumnWastedMenu = () => {
    var newColumns = wastedmenucolumns;
    const voidcol = [
      {
        title: "Void",
        render: (text, record, index) => {
          return (
            <Popconfirm
              title="Are you sure you want to void this item?"
              onConfirm={() => {
                voidThisWastedMenu(record);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button type="danger" loading={loading}>
                void
              </Button>
            </Popconfirm>
          );
        },
      },
    ];

    if (user.role == "admin" || user.role == "manager") {
      newColumns = newColumns.concat(voidcol);
    }

    return newColumns;
  };

  const filterColumnWastedItems = () => {
    var newColumns = wastesColumns;
    const voidcol = [
      {
        title: "Void",
        render: (text, record, index) => {
          return (
            <Popconfirm
              title="Are you sure you want to void this item?"
              onConfirm={() => {
                voidThisWasteditems(record);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button type="danger" loading={loading}>
                void
              </Button>
            </Popconfirm>
          );
        },
      },
    ];

    if (user.role == "admin" || user.role == "manager") {
      newColumns = newColumns.concat(voidcol);
    }

    return newColumns;
  };

  const pulloutColumns = [
    {
      title: "Branch",
      dataIndex: "branch_name",
      key: "branch_name",
      filters: createDestinationFilter(),
      onFilter: (value, record) => value.includes(record.branch_name),
      sorter: (a, b) => a.branch_name.localeCompare(b.branch_name),
    },
    {
      title: "Create Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
      render: (text, record, index) => {
        return (
          <div className="vertical">
            <span> create date: </span>
            <span> {moment(record.created_at).format("LLL")} </span>
            <span>{"-----------"}</span>
            <span> {record.created_name}</span>
          </div>
        );
      },
    },
    {
      title: "Pulled Out Items",

      render: (text, record, index) => {
        return (
          <List
            className="Itemlist"
            itemLayout="horizontal"
            dataSource={record.pullout_items}
            size={"small"}
            renderItem={(item) => (
              <List.Item
              // actions={[
              //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
              //     <DeleteOutlined  />
              //   </Button>
              // ]}
              >
                <List.Item.Meta
                  avatar={
                    <ImageChecker
                      url={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                      success={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}${item.id}.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                      fail={
                        <img
                          src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                          alt="image"
                          className={"prodimagesmall"}
                        />
                      }
                    />
                  }
                  title={<h7>{item.name}</h7>}
                  description={
                    <div className="horizontalItem">
                      <div className="horizontalItem">
                        {item.second_unit_rate &&
                        item.second_unit &&
                        parseFloat(item.second_unit_rate) > 0 ? (
                          <label>
                            {" "}
                            x
                            {`${(
                              parseFloat(item.pull_out_quantity) /
                              parseFloat(item.second_unit_rate)
                            ).toFixed(2)}`}{" "}
                          </label>
                        ) : (
                          <label> x{item.pull_out_quantity} </label>
                        )}
                        {item.second_unit_rate &&
                        item.second_unit &&
                        parseFloat(item.second_unit_rate) > 0 ? (
                          <label className="tinyText">{item.second_unit}</label>
                        ) : (
                          <label className="tinyText">{item.unit}</label>
                        )}
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        );
      },
    },
  ];

  const tabItems = [
    { key: "daily", label: "Sales" },
    ...(user?.role == "admin"
      ? [{ key: "voided", label: "Voided Sales" }]
      : []),
    // { key: "wastedmenu", label: "Wasted Menu" },
    // { key: "wasted", label: "Wasted Items" },
    // // conditionally add “Pull Out” for certain roles
    // ...(["admin", "oic", "manager"].includes(user?.role)
    //   ? [{ key: "pullout", label: "Pull Out" }]
    //   : []),
  ];

  return (
    <div className="maindiv">
      {processingMessage ? (
        <div className="page-processing-overlay">
          <div className="page-processing-box">
            <Spin size="large" />
            <span>{processingMessage}</span>
          </div>
        </div>
      ) : null}
      <div className={"generic_container"}>
        <PageHeader
          title={PAGENAME + "s"}
          subTitle={
            <div className={"dailysales_header"}>
              {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
            </div>
          }
          extra={
            <div className={"dailysales_header"}>
              {tabMode == "daily" ? (
                <PosSalesModal
                  onClose={() => {
                    setResetTable(!resetTable);
                  }}
                />
              ) : null}
              {tabMode == "wastedmenu" ? (
                <AddWastedMenuModal
                  onModalClose={() => {
                    setResetTable(!resetTable);
                  }}
                />
              ) : null}

              {tabMode == "wasted" ? (
                <AddWastedItemsModal
                  onModalClose={() => {
                    setResetTable(!resetTable);
                  }}
                />
              ) : null}

              {tabMode == "pullout" ? (
                <AddPulloutModal
                  onModalClose={() => {
                    setResetTable(!resetTable);
                  }}
                />
              ) : null}

              {crudDataCount > 0 ? (
                <Button
                  type={"primary"}
                  shape={"round"}
                  onClick={() => {
                    if (tabMode == "daily" || tabMode == "voided") {
                      dispatch(loadMoreSalesData());
                    }

                    if (tabMode == "wastedmenu") {
                      dispatch(loadMoreWastedMenuData());
                    }
                    if (tabMode == "wasted") {
                      dispatch(loadMoreWastableData());
                    }

                    if (tabMode == "pullout") {
                      dispatch(loadMorePullOutData());
                    }
                  }}
                  style={{ marginRight: "1em" }}
                >
                  Load More
                </Button>
              ) : null}

              <Button
                onClick={() => {
                  setResetTable(!resetTable);
                }}
                className="button"
              >
                <ReloadOutlined />
              </Button>
            </div>
          }
        ></PageHeader>
        <Tabs
          activeKey={tabMode}
          onChange={setTabMode}
          moreIcon={null}
          items={tabItems}
          tabBarStyle={{ marginLeft: "5vw" }}
        />
        <div className={"content_container"}>
          {tabMode == "daily" || tabMode == "voided" ? (
            <SalesTable
              ref={tableRef}
              apiurl={API_URL}
              columns={filterColumnSales()}
              mainSearch={mainSearch}
              resetTable={resetTable}
              ChangedSelected={(selected) => {
                itemSelected(selected);
              }}
              rowClick={(selected) => {
                itemSelected(selected);
              }}
              showVoided={tabMode == "voided"}
              salesStatus={tabMode == "voided" ? "voided" : "completed"}
            />
          ) : null}

          {/* {tabMode == "wastedmenu" ? (
            <WastedMenuTable
              ref={tableRef}
              apiurl={"wastedmenu"}
              columns={filterColumnWastedMenu()}
              mainSearch={mainSearch}
              resetTable={resetTable}
              ChangedSelected={(selected) => {
                itemSelected(selected);
              }}
              rowClick={(selected) => {
                itemSelected(selected);
              }}
            />
          ) : null}

          {tabMode == "wasted" ? (
            <WasteTable
              ref={tableRef}
              apiurl={"wastes"}
              columns={filterColumnWastedItems()}
              mainSearch={mainSearch}
              resetTable={resetTable}
              ChangedSelected={(selected) => {
                itemSelected(selected);
              }}
              rowClick={(selected) => {
                itemSelected(selected);
              }}
            />
          ) : null}

          {tabMode == "pullout" ? (
            <PullOutTable
              ref={tableRef}
              apiurl={"pullout"}
              columns={pulloutColumns}
              mainSearch={mainSearch}
              resetTable={resetTable}
              ChangedSelected={(selected) => {
                itemSelected(selected);
              }}
              rowClick={(selected) => {
                itemSelected(selected);
              }}
            />
          ) : null} */}
        </div>
      </div>
    </div>
  );
};

export default Index;
